<div class="loading-container" *ngIf="!disableLoading">
    <app-logout *ngIf="LogoutBtn"></app-logout>
    <div class="preloader">
    </div>
  </div>
